import React from 'react';

import AuthVector from '~assets/images/auth/auth_vector.svg?react';

import styles from './AuthLayout.module.scss';

interface AuthLayoutProps {
	children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	return (
		<div className={styles.authLayout}>
			{children}
			<div className={styles.authVector}>
				<AuthVector />
			</div>
		</div>
	);
};

export default AuthLayout;
